// Sohel 04/27/2023 3225736869 removed default username and password
import React, {useEffect, useState, useContext} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import PageLoader from '../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../components/CustomSnackBar';
// import {postLogIn, resetlogInStatus, resetMsg} from '../../redux/reducers/Login';
import { resetlogInStatus, resetMsg} from '../../redux/reducers/Login';
import SelectTabContextProvider from '../../components/SelectTabContext/SelectTabContext';
import Revon from '../../assets/images/RevOne_green-logo.png';

import openeye from '../../assets/images/openeye.png';
import {useHistory} from 'react-router';
import CbsLogo from '../../assets/images/cbs-logo.png';

function App() {
  const {expiryMsg, setSelectedTabs, setSelectedCMTabs} = useContext(SelectTabContextProvider);
  const history = useHistory();
  const dispatch = useDispatch();
  const {logInStatus, token, isLoading, errorMsg, successMsg} = useSelector(({logIn}) => logIn);
  const [userName, setUserName] = useState('');
  const [passWord, setPassword] = useState('');
  const [passwordShown, setPasswordShown] = useState(false);
  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };
  const handleUserName = (event) => {
    setUserName(event.target.value);
  };
  const handlePassword = (event) => {
    setPassword(event.target.value);
  };
  useEffect(() => {
    if (logInStatus === 200) {
      setSelectedTabs([]);
      setSelectedCMTabs([]);
      sessionStorage.setItem('token', token);
      location?.state ?
        history.push(location?.state?.from.pathname) :
        history.push('/account-summary');
      dispatch(resetlogInStatus());
    }
  }, [logInStatus]);
  useEffect(() => {
    setTimeout(() => {
      dispatch(resetMsg());
    }, 10000);
  }, [logInStatus]);
  useEffect(() => {
    return () => {
      dispatch(resetMsg());
    };
  }, []);
  const handleLogIn = () => {
    if (userName && passWord) {


      // dispatch(
      //   postLogIn({
      //     username: userName,
      //     password: passWord,
      //   }),
      // );
    }
  };
  return (
    <div className="App">
      <div className="login-page2">
        <div className="container">
          <div className="main-content">
            <div className="header">
              <div className="company-logo">
                <img src={Revon} alt="navigation-logo" />
              </div>
            </div>
            <div className="form-content">
              <div className="header"></div>
              <div className="cbs-logo">
                <img src={CbsLogo} className="img-fluid" alt="Cbs-Logo" />
              </div>
              {/* <h4 role="heading" aria-level="1">
              Welcome!
              </h4>
              <p>Please login using your account</p> */}
              <form>
                <div className="form-group login-fields">
                  <label>USERNAME34</label>
                  <input
                    type="text"
                    className="form-control"
                    value={userName}
                    onChange={(e) => handleUserName(e)}
                    aria-label="Username"
                  />
                </div>
                <div className="form-group login-fields">
                  <label>PASSWORD</label>
                  <input
                    type={passwordShown ? 'text' : 'password'}
                    className="form-control"
                    placeholder=""
                    value={passWord}
                    onChange={(e) => handlePassword(e)}
                  />
                  <img
                    src={openeye}
                    alt="openeye-logo"
                    onClick={() => togglePassword()}
                    className="password-img"
                  />
                </div>
                <div className="more-info">
                  <div className="forgot-pw">
                    <a href="/">Forgot your password?</a>
                  </div>
                  <div className="reset">
                    <a href="/">Reset Here</a>
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => handleLogIn()}
                  className="login-btn btn-block mb-0"
                >
                  LOGIN
                </button>

                {/* <button type="submit" className="signup-btn btn-block">
                CREATE AN ACCOUNT
                </button> */}
              </form>
            </div>
          </div>
          {/* <div className="copyright">
            <p style={{ color: "#000" }}>&copy;2021 PDS Galaxy</p>
          </div> */}
        </div>
      </div>
      {isLoading && <PageLoader />}
      {(errorMsg || expiryMsg) && (
        <ErrorSnackbar errorMsg={errorMsg || expiryMsg} loginPage={true} />
      )}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </div>
  );
}

export default App;
